import * as angular from "angular";
import * as  rrule from "rrule";
import * as _ from "lodash";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ScheduleAlertsService} from "./schedule-alerts.service";
import {ScheduleRequestsService} from "./schedule-requests.service";
import {ScheduleType} from "../types/schedule.type";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";

export class ScheduleService {

  DOW_NAMES: any;


  constructor(private scheduleRequestsService: ScheduleRequestsService, private scheduleAlertsService: ScheduleAlertsService, private commonsConstants,
              private $q: IQService, private bringozLoaderService: BringozLoaderService, private moment, private splitService, private $filter,
              private commonsAlertsService: CommonsAlertsService) {
    this.DOW_NAMES = this.commonsConstants.dayArray;
  }

  getSchedulePayload(startTime, endTime, startRecurring, endRecurring, freq, interval?, zoneId?) {
    return {
      startTime: startTime || this.moment().startOf('day').valueOf(),
      endTime: endTime || this.moment().endOf('day').minute(45).seconds(0).millisecond(0).valueOf(),
      interval: interval || 1,
      freq: freq,
      startRecurring: startRecurring,
      endRecurring: endRecurring,
      dow: [],
      zoneIdName: zoneId,
      byWeekDay: freq === 'WEEKLY' ? [this.DOW_NAMES[this.moment(startRecurring).day()].substring(0, 2)] : []
    }
  }

  parseManyScheduleToEventsByRange(schedule?, from?, to?, agentId?, zoneId?) {
    let events = [];
    const dayInMili = 8.64e+7;
    const monthInMili = 2592000000;

    _.forEach(schedule, (s) => {
      const recurringString = _.get(s, 'schedule.rrule', '');

      if (recurringString) {
        const startRecurring = _.get(s, 'schedule.startRecurring');

        const ruleOptions = rrule.RRule.parseString(recurringString);
        ruleOptions.dtstart = this.moment(s.schedule.startRecurring).utc(true).toDate()
        if (s.schedule.endRecurring) {
          ruleOptions.until = this.moment(s.schedule.endRecurring).utc(true).toDate();
        }


        const rule = new rrule.RRule(ruleOptions);
        let dates = rule.between(this.moment(from - dayInMili).toDate(), this.moment(to + dayInMili).toDate());

        // convert to local
        dates = _.map(dates, (d) => {
          return this.moment(d).set({
            year: this.moment.utc(d).year(),
            month: this.moment.utc(d).month(),
            date: this.moment.utc(d).date()
          }).startOf('day').toDate();
        })

        const exceptions = _.get(s, 'schedule.exceptions', []);

        if (exceptions.length) {
          dates = _.filter(dates, (d) => {
            const exception = _.find(exceptions, (e) => {
              return this.moment(d).isSame(this.moment(e), 'date');
            });
            return _.isUndefined(exception);
          });
        }

        events = events.concat(this.parseReacquiringScheduleToEvents(s, dates, agentId, zoneId)); //ResourceAllocation | AgentSchedule;
      } else if (s.schedule.startTime >= this.moment(from).valueOf() && s.schedule.endTime <= this.moment(to).valueOf()) {
        events.push(this.parseScheduleToEvent(s, s.schedule.startTime, s.schedule.endTime, agentId, zoneId));
      }
    });

    return events;
  }

  getRecurringInfo(agentSchedule) {
    const schedule = agentSchedule?.schedule;
    if (!schedule?.rrule) {
      return null;
    }
    return {
      freqKey: schedule?.freq,
      byWeekDay: schedule?.byWeekDay || []
    };
  }

  getAll(from, to, agentType, branchIds, returnInstances) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getAll(from, to, agentType, branchIds, returnInstances)
      .then((schedule) => {
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getByAgentId(agentId: string, from: string, to: string, scheduleTypes?: ScheduleType[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getByAgentId(agentId, from, to, scheduleTypes)
      .then((schedule) => {
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  getByAgentIds(agentIds, from, to, scheduleTypes?, serviceAreaIds?, excludeScheduleTemplate?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getByAgentIds(agentIds, from, to, scheduleTypes, serviceAreaIds, excludeScheduleTemplate)
      .then((schedules) => {
        deferred.resolve(schedules)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getSchedules(agentIds, from, to, serviceAreaIds, excludeScheduleTemplate?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getByAgentIds(agentIds, from, to, serviceAreaIds, excludeScheduleTemplate)
      .then((schedules) => {
        deferred.resolve(schedules)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createManyByAgentId(schedule, agentId) {
    if (this._isLeaveCreation(schedule)) {
      return this.createLeaveByAgentId(schedule[0], agentId);
    }

    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.validateManyByAgentId(schedule, agentId)
      .then(() => this.scheduleRequestsService.createManyByAgentId(schedule, agentId))
      .then((createdSchedule) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(createdSchedule)
      })
      .catch((error) => {
        const isConflict = error?.status === 409;
        if (!isConflict) {
          this.scheduleAlertsService.createError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createManyByAgentIdIgnoringConflicts(schedule, agentId) {
    if (this._isLeaveCreation(schedule)) {
      return this.createLeaveByAgentId(schedule[0], agentId);
    }

    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.createManyByAgentId(schedule, agentId)
      .then((createdSchedule) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(createdSchedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createLeaveByAgentId(agentSchedule, agentId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.createLeaveByAgentId(this.getLeavePayload(agentSchedule), agentId)
      .then((createdSchedules) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(createdSchedules)
      })
      .catch((error) => {
        const isConflict = error?.status === 409;
        if (isConflict) {
          this.scheduleAlertsService.createLeaveOverlapError();
        } else {
          this.scheduleAlertsService.createError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getLeavePayload(agentSchedule) {
    const schedule = _.get(agentSchedule, 'schedule', {});
    const hasFixedDuration = !!_.get(agentSchedule, 'absenceReason.durationInMinutes');

    return {
      absenceReasonId: _.get(agentSchedule, 'absenceReason.id'),
      startDate: schedule.startTime,
      endDate: schedule.endTime,
      startTime: schedule.startTime,
      endTime: hasFixedDuration ? null : schedule.endTime
    };
  }

  autoCreate(from, to, holderId: string, holderType: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.autoCreate(from, to, holderId, holderType)
      .then((schedule) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getOneByAgentId(scheduleId: string, agentId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getOneByAgentId(scheduleId, agentId)
      .then((schedule) => {
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError()
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getManyByIds(ids: string[], agentId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getManyByIds(ids, agentId)
      .then((schedules) => {
        deferred.resolve(schedules);
      })
      .catch((error) => {
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateOneByAgentId(schedule, scheduleId, agentId, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.updateOneByAgentId(schedule, scheduleId, agentId, type, instanceDate)
      .then((schedule) => {
        this.scheduleAlertsService.updateSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        const isConflict = error?.status === 409 || error?.data?.status === 409 || error?.code === 40903 || error?.data?.code === 40903;
        if (!isConflict) {
          this.scheduleAlertsService.updateError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateScheduleExtraData(scheduleExtraDataPayloadList, zoneId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.updateScheduleExtraData(scheduleExtraDataPayloadList, zoneId)
      .then((updatedExtraDataObject) => {
        this.scheduleAlertsService.updateSuccess();
        deferred.resolve(updatedExtraDataObject)
      })
      .catch((error) => {
        this.scheduleAlertsService.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteOneByAgentId(scheduleId, agentId, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.deleteOneByAgentId(scheduleId, agentId, type, instanceDate)
      .then((schedule) => {
        this.scheduleAlertsService.deleteOneSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.deleteOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getScheduleTimeline(scheduleId, from, to) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getScheduleTimeline(scheduleId, from, to)
      .then((schedule) => {
        deferred.resolve(schedule)
      })
      .catch((error) => {
        // scheduleAlertsService.deleteOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getByDepotId(id, from, to, programType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getByDepotId(id, from, to, programType)
      .then((schedule) => {
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createManyByDepotId(schedule, id) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.createManyByDepotId(schedule, id)
      .then((schedule) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOneByDepotId(schedule, scheduleId, id, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.updateOneByDepotId(schedule, scheduleId, id, type, instanceDate)
      .then((schedule) => {
        this.scheduleAlertsService.updateSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteOneByDepotId(scheduleId, id, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.deleteOneByDepotId(scheduleId, id, type, instanceDate)
      .then((schedule) => {
        this.scheduleAlertsService.deleteOneSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.deleteOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getAllTemplates() {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getAllTemplates()
      .then((templates) => {
        deferred.resolve(templates)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getTemplateById(templateId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getTemplateById(templateId)
      .then((template) => {
        deferred.resolve(template)
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createTemplate(template) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.createTemplate(template)
      .then((template) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(template)
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateTemplate(template) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.updateTemplate(template)
      .then((template) => {
        this.scheduleAlertsService.updateSuccess();
        deferred.resolve(template)
      })
      .catch((error) => {
        this.scheduleAlertsService.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getTemplateAgents(templateId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getTemplateAgents(templateId)
      .then((template) => {
        deferred.resolve(template)
      })
      .catch((error) => {
        this.scheduleAlertsService.getTemplateAgentsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getTemplateSchedule(templateId, from, to) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getTemplateSchedule(templateId, from, to)
      .then((template) => {
        deferred.resolve(template)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createTemplateSchedule(templateId, schedule) {
    var deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.createTemplateSchedule(templateId, schedule)
      .then((createdSchedule) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(createdSchedule);
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateTemplateSchedule(templateId, scheduleId, schedule, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.updateTemplateSchedule(templateId, scheduleId, schedule, type, instanceDate)
      .then((updatedSchedule) => {
        this.scheduleAlertsService.updateSuccess();
        deferred.resolve(updatedSchedule);
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteTemplate(templateId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.deleteTemplate(templateId)
      .then((deletedTemplate) => {
        this.scheduleAlertsService.deleteOneSuccess();
        deferred.resolve(deletedTemplate);
      })
      .catch((error) => {
        this.scheduleAlertsService.deleteOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteTemplateSchedule(templateId, scheduleId, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.deleteTemplateSchedule(templateId, scheduleId, type, instanceDate)
      .then((updatedSchedule) => {
        this.scheduleAlertsService.deleteOneSuccess();
        deferred.resolve(updatedSchedule);
      })
      .catch((error) => {
        this.scheduleAlertsService.deleteOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  //branches:
  getByBranchId(from, to, agentId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.getByBranchId(from, to, agentId)
      .then((schedule) => {
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createManyByBranchId(schedule, agentId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.createManyByBranchId(schedule, agentId)
      .then((schedule) => {
        this.scheduleAlertsService.createSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOneByBranchId(schedule, scheduleId, agentId, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.updateOneByBranchId(schedule, scheduleId, agentId, type, instanceDate)
      .then((schedule) => {
        this.scheduleAlertsService.updateSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteOneByBranchId(scheduleId, agentId, type, instanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.deleteOneByBranchId(scheduleId, agentId, type, instanceDate)
      .then((schedule) => {
        this.scheduleAlertsService.deleteOneSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.deleteOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  approveSchedule(payload: {id: string, from: string, to: string}[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.approveSchedule(payload)
      .then((schedule) => {
        this.scheduleAlertsService.approveOneSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.approveOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  rejectSchedule(ids: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.rejectSchedule(ids)
      .then((schedule) => {
        this.scheduleAlertsService.rejectOneSuccess();
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.rejectOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportAgentSchedules(params) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.scheduleRequestsService.exportAgentSchedules(params)
      .then(() => {
        this.commonsAlertsService.exportToMailSuccess();
        deferred.resolve();
      })
      .catch((error) => {
        this.commonsAlertsService.exportToMailError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  private parseReacquiringScheduleToEvents(schedule, dates, agentId, zoneId) {

    return _.map(dates, (date) => {

      const dateToDifferenceInMili = this.moment(schedule.schedule.endTime).diff(this.moment(schedule.schedule.startTime));
      const dateFrom = this.moment(date).set({
        // year: this.moment.utc(date).year(),
        // month: this.moment.utc(date).month(),
        // date: this.moment.utc(date).date(),
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date(),
        hour: this.moment(schedule.schedule.startTime).hours(),
        minute: this.moment(schedule.schedule.startTime).minutes(),
        second: this.moment(schedule.schedule.startTime).seconds()
      });
      const dateTo = this.moment(dateFrom.valueOf() + dateToDifferenceInMili);


      return this.parseScheduleToEvent(schedule, dateFrom, dateTo, agentId, zoneId);
    })
  }

  private parseScheduleToEvent(schedule, from, to, agentId, zoneId?) {

    let startTime;
    let endTime;
    const isRecurring = !!schedule?.schedule?.templateId && !schedule.schedule.template && !schedule.schedule.overridden;


    // if (false) {
    //     var startHour = from.hour();
    //     var startMin = from.minute();
    //
    //     var diff = to.diff(from);
    //
    //     var diffDuration = moment.duration(diff);
    //
    //     var daysDiff = diffDuration.days(),
    //         hoursDiff = diffDuration.hours(),
    //         minutesDiff = diffDuration.minutes();
    //
    //     var endTimeHour = $filter('bringozPaddingZeros')((startHour + ( (daysDiff * 24) +  hoursDiff)), 2);
    //     var endTimeMinute = $filter('bringozPaddingZeros')((startMin + minutesDiff), 2);
    //
    //     startTime = from.format("HH:mm");
    //     endTime = endTimeHour.toString() + ':' + endTimeMinute.toString();
    //
    // } else {
    //     startTime = new Date(from);
    //     endTime = new Date(to);
    // }

    startTime = new Date(from);
    endTime = new Date(to);

    let title = schedule.name;
    const classNames = [];
    classNames.push(schedule.holderId === agentId ? 'AGENT' : 'TEMPLATE',);
    classNames.push(schedule.type);


    return {
      // index: index,
      dataRef: schedule,
      title: title,
      className: classNames,
      isRecurring: isRecurring,
      // backgroundColor: 'rgba(249, 29, 95, 0.5)',
      // className: 'agent-event',
      zoneId: zoneId,
      start: startTime, // start time (10:00) or date
      end: endTime, // end time (15:00 || 25:00 for next day at 01:00) or date
      notBefore: from,
      notAfter: to,
      // editable: false
      // durationEditable: false
      // dow: isRecurring ? schedule.schedule.dow : [moment(schedule.schedule.startTime).day()],
    }
  }

  private _isLeaveCreation(schedules) {
    return _.isArray(schedules) && schedules.length === 1 && _.get(schedules[0], 'type') === ScheduleType.Leave;
  }

}

angular
  .module('bringoz.admin.schedule')
  .service('scheduleService', ScheduleService);
